// extracted by mini-css-extract-plugin
module.exports = {"button":"buttonConfirm_button__3PwQq"};